<script>
import formatDate, { subDate, addDate } from '@utils/format-date'
import { TIME_SELECT } from '@utils/constant'
export default {
  props: {
    range: {
      type: String,
      default: 'days',
      require: true,
    },
    endDate: {
      type: String,
      default: '',
      require: false,
    },
  },
  data() {
    return {
      TIME_SELECT: TIME_SELECT,
    }
  },
  methods: {
    moveTo(next, step) {
      let date
      let type
      switch (this.range) {
        case this.TIME_SELECT.day:
          type = 'days'
          break
        case this.TIME_SELECT.week:
          type = 'weeks'
          break
        case this.TIME_SELECT.month:
          type = 'months'
          break
        default:
          break
      }
      if (next) {
        date = addDate(this.endDate, type, step)
      } else {
        date = subDate(this.endDate, type, step)
      }
      date = formatDate(date)
      this.$emit('getDate', date)
    },
  },
}
</script>

<template>
  <div class="d-flex justify-content-between mt-5">
    <div>
      <CButton
        type="button"
        color="dark"
        variant="outline"
        class="px-3 pt-0 pb-0 mr-2"
        size="sm"
        @click="moveTo(false, 13)"
      >
        &#60;&#60;
      </CButton>
      <CButton
        type="button"
        color="dark"
        variant="outline"
        class="px-3 pt-0 pb-0"
        size="sm"
        @click="moveTo(false, 0)"
      >
        &#60;
      </CButton>
    </div>
    <div>
      <CButton
        type="button"
        color="dark"
        variant="outline"
        class="px-3 pt-0 pb-0 mr-2"
        size="sm"
        @click="moveTo(true, 2)"
      >
        &#62;
      </CButton>
      <CButton
        type="button"
        color="dark"
        variant="outline"
        class="px-3 pt-0 pb-0"
        size="sm"
        @click="moveTo(true, 15)"
      >
        &#62;&#62;
      </CButton>
    </div>
  </div>
</template>
